import { Link } from "gatsby"
import React from "react"
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa"
import { IconContext } from "react-icons"

export default function Footer({ currentYear }) {
  return (
    <footer className="page-footer">
      <div className="bg-footer border-bottom">
        <div className="container ">
          <div className="row">
            <div
              className="col-12 py-5 
            text-center mx-auto"
            >
              <IconContext.Provider value={{ color: "white", size: "2em" }}>
                <Link to="https://www.instagram.com/aashish_paliwal_1999/">
                  <FaInstagram className="fab insta-icon mr-5" />
                </Link>
                <Link to="https://www.facebook.com/aashish.paliwal.353/">
                  <FaFacebookF className="fab fb-icon mr-5" />
                </Link>
                <Link to="https://www.linkedin.com/in/aashish-paliwal-00a668183/">
                  <FaLinkedinIn className="fab ln-icon mr-5" />
                </Link>
                <Link to="https://twitter.com/Aashish_12_99">
                  <FaTwitter className="fab twt-icon" />
                </Link>
              </IconContext.Provider>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-footer-2">
        <div
          className="col-12 col-xs-12 col-sm-12 col-md-10 
              col-lg-8 pt-2 mx-auto 
              text-center text-muted display-5 py-2"
        >
          &copy; {currentYear} Copyright:
          <a
            href="https://ap-ecom.netlify.app/"
            className="display-5 text-light"
          >
            {" "}
            AP_Ecom.com
          </a>
        </div>
      </div>
    </footer>
  )
}
